import { Cirus } from "@/classes/Http";
import { AxiosResponse } from "axios";
import { IsDate, IsEmail, IsEnum, IsMobilePhone, IsNumberString, IsOptional, IsPhoneNumber, IsString, IsUrl, IsUUID, Length, MaxLength, MinLength, validate, ValidateIf } from "class-validator";
import { Message } from "element-ui";

enum Sex {
    Male = "male",
    Female = "female",
    Unknown = "na"
}

const errorMessages : any = {
    name: "لطفا نام و نام خانوادگی را صحیح وارد کنید.",
    username: "نام کاربری خود را بررسی کنید.",
    mobile: "لطفا شماره همراه را صحیح وارد کنید.",
    password: "رمز عبور باید حداقل ۸ حرف باشد.",
    email: "ایمیل را صحیح وارد کنید.",
    father: "نام پدر را بررسی کنید.",
    id_card: "کارت ملی را صحیح وارد کنید",
    sex: "جنسیت را صحیح وارد کنید.",
    referral_code: "کد معرف را صحیح وارد کنید."
}

export class UpdateUserBody {

    constructor(
        body: UpdateUserBody
    ) {
        this.id = body.id;
        this.name = body.name || null;
        this.mobile = body.mobile || null;
        this.email = body.email || null;
        this.sex = body.sex || null;
        this.description = body.description || null;
        this.id_card = body.id_card || null;
        this.father = body.father || null;
        this.birthdate = body.birthdate || null;
        this.phone = body.phone || null;
        this.website = body.website || null;
        this.id_card_image_id = body.id_card_image_id || null;
        this.license_image_id = body.license_image_id || null;
        this.avatar_id = body.avatar_id || null;
    }

    @IsUUID()
    id: string;

    @IsString()
    @MinLength(2)
    name: string;

    @ValidateIf(o => !o.email || o.mobile)
    @IsMobilePhone()
    mobile: string;

    @ValidateIf(o => !o.mobile || o.email)
    @IsEmail()
    email: string;

    @IsEnum(Sex)
    sex: Sex;

    @IsString()
    @IsOptional()
    @MaxLength(256)
    description: string;

    @IsString()
    @MinLength(10)
    @MaxLength(10)
    @IsOptional()
    id_card: string;

    @IsString()
    @IsOptional()
    @MaxLength(32)
    father: string;

    @IsDate()
    @IsOptional()
    birthdate: Date;

    @IsPhoneNumber()
    @IsOptional()
    phone: string;

    @IsUrl()
    @IsOptional()
    website: string;

    @IsUUID()
    @IsOptional()
    id_card_image_id: string;

    @IsUUID()
    @IsOptional()
    license_image_id: string;

    @IsUUID()
    @IsOptional()
    avatar_id: string;
}

export async function updateUser(body: UpdateUserBody): Promise<AxiosResponse<{err: string}>>{
    body = new UpdateUserBody(body);    
    const errors = await validate(body);
    if (errors.length>0)  {
        Message.error(errorMessages[errors[0].property])
        throw new Error("اطلاعات وارد شده صحیح نمی ‌باشد.");
    }
    
    const query = '/user/update';
    return Cirus.post(query, body, null, null, process.env.VUE_APP_apiURL, {409: 'این شماره همراه پیش تر ثبت نام کرده است.'});
}
